var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_84_134",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_84_134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 7.79484C7.35833 7.79484 6.80906 7.5664 6.35217 7.10951C5.89517 6.65251 5.66667 6.10317 5.66667 5.46151C5.66667 4.81984 5.89517 4.27056 6.35217 3.81367C6.80906 3.35667 7.35833 3.12817 8 3.12817C8.64167 3.12817 9.19094 3.35667 9.64783 3.81367C10.1048 4.27056 10.3333 4.81984 10.3333 5.46151C10.3333 6.10317 10.1048 6.65251 9.64783 7.10951C9.19094 7.5664 8.64167 7.79484 8 7.79484ZM3 11.859V11.3897C3 11.0632 3.08867 10.7609 3.266 10.4827C3.44333 10.2045 3.68033 9.99056 3.977 9.84101C4.63589 9.51801 5.30061 9.27573 5.97117 9.11417C6.64172 8.95262 7.318 8.87184 8 8.87184C8.682 8.87184 9.35828 8.95262 10.0288 9.11417C10.6994 9.27573 11.3641 9.51801 12.023 9.84101C12.3197 9.99056 12.5567 10.2045 12.734 10.4827C12.9113 10.7609 13 11.0632 13 11.3897V11.859C13 12.1401 12.9015 12.3792 12.7045 12.5763C12.5075 12.7733 12.2684 12.8718 11.9872 12.8718H4.01283C3.73161 12.8718 3.4925 12.7733 3.2955 12.5763C3.0985 12.3792 3 12.1401 3 11.859ZM4 11.8718H12V11.3897C12 11.2547 11.9609 11.1297 11.8827 11.0147C11.8044 10.8998 11.6983 10.806 11.5642 10.7333C10.9897 10.4505 10.4041 10.2361 9.80717 10.0903C9.21017 9.94467 8.60778 9.87184 8 9.87184C7.39222 9.87184 6.78983 9.94467 6.19283 10.0903C5.59594 10.2361 5.01028 10.4505 4.43583 10.7333C4.30172 10.806 4.19556 10.8998 4.11733 11.0147C4.03911 11.1297 4 11.2547 4 11.3897V11.8718ZM8 6.79484C8.36667 6.79484 8.68056 6.66428 8.94167 6.40317C9.20278 6.14206 9.33333 5.82817 9.33333 5.46151C9.33333 5.09484 9.20278 4.78095 8.94167 4.51984C8.68056 4.25873 8.36667 4.12817 8 4.12817C7.63333 4.12817 7.31944 4.25873 7.05833 4.51984C6.79722 4.78095 6.66667 5.09484 6.66667 5.46151C6.66667 5.82817 6.79722 6.14206 7.05833 6.40317C7.31944 6.66428 7.63333 6.79484 8 6.79484Z",
    fill: "#50464B"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.c04b9a0199d0847a9684fc5bc29b37e4.svg";
export { ForwardRef as ReactComponent };